<div class="step-template" *ngIf="!type || type != advType">
    <div *ngIf="! previewMode" 
        class="slash-section mx-auto">
        <img class="splash-image" [src]="fullSplashPath" [alt]="splashImageAlt" />
    </div>

    <div class="modal-header">
        <!-- <span *ngIf="jobTitle" class="section-title" ngbTooltip="{{summaryTooltipText}}">{{jobTitle}}</span> -->
        <h1 class="modal-title cc-h1">{{jobTitle}}
        <span *ngIf="!previewMode && toolTipText != ''"
            class="cc-tooltip" 
            ngbTooltip="{{toolTipText}}" [autoClose]="true" triggers="click">&nbsp;</span>
        </h1>
        <h2 class="cc-h2">{{heading}}</h2>
        <div class="cc-custom-separator"></div>
    </div>

    <div *ngIf="! previewMode && supplimentals && supplimentals.length > 0"
        class="section-sponsors row mb-3 mt-3" >
        <div class="sponsor col pl-0 pr-0" 
            *ngFor="let sponsor of supplimentals; let index = index">
            
            <a class="cc-{{sponsor?.type}}"
                target="_blank" 
                href="{{sponsor?.url}}" 
                title="{{sponsor?.message}}">
                
                <span class="sponsor-icon pr-2 pr-sm-3">★</span>
                {{sponsor?.message}}
                <i class="fas fa-solid fa-chevron-right"></i>
            </a>
        </div>
    </div>

    <div class="content splash-list-section cp-top-border" 
        [ngClass]="previewMode ? 'preview-mode': ''">
        <p>{{detailExplanation}}</p>

        <ul class="splash-list ps-0 ps-md-3">
            <li *ngFor="let item of detailItems | slice:0:2" class="pb-1 pb-sm-3">
                <i class="fas fa-square pr-1 pr-sm-3"><img src="../../../assets/images/icons/checkbox.svg" /></i>
                {{item.subject}}
            </li>
            <!-- Collapse remaining items -->
            <ng-template [ngIf]="detailItems.length >= 3">
                <div #collapse="ngbCollapse" [ngbCollapse]="isMoreStepsCollapsed">
                    <li *ngFor="let item of detailItems | slice:2" class="pb-1 pb-sm-3">
                        <i class="fas fa-square pr-1 pr-sm-3"><img src="../../../assets/images/icons/checkbox.svg" /></i>
                        {{item.subject}}
                    </li>
                </div>
                <p class="expand-collapse-link mt-3 p-0"
                    (click)="isMoreStepsCollapsed = !isMoreStepsCollapsed;"
                    [attr.aria-expanded]="!isMoreStepsCollapsed">
                    <span class="cc-custom-separator d-block"></span>
                    <span class="d-block collapselogo text-center fw-bold mx-auto" 
                        [ngClass]="{ 
                            'more-arrow-down': isMoreStepsCollapsed, 
                            'more-arrow-up' : !isMoreStepsCollapsed
                        }"><img src="../../../assets/images/icons/down-arrow.png"></span>
                </p>
            </ng-template>
        </ul>
    </div>
    
</div>
<div class="step-template adv-template" *ngIf="type == advType">
    <a href="">
        <img class="adv-image" [src]="fullSplashPath" [alt]="splashImageAlt" />
    </a>
</div>